module.exports = __webpack_public_path__ + "img/carrousel-mov-digi-4.ec579a06.png";